import LoadingSpinner from "@/common/loading"
import { DataContext } from "@/contexts"
import BRTThemeProvider from "@/providers/theme"
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"
import React, { useContext } from "react"
import useFetchLessons from "./hooks/useFetchLessons"
import styled from "styled-components"

const NoAssignmentSessions = () => {
  return (
    <h6 className="font-weight-normal mb-0 flex-grow-1 mt-4 font-size-medium">
      A record of the assignments you assign to your sessions will appear here.
    </h6>
  )
}
const StyledTableHeader = styled(TableRow)(() => ({
  "& td": {
    border: 0,
    paddingLeft: 0,
  },
  "& th": { paddingLeft: 0 },
}))

const StyledTableRow = styled(TableRow)(() => ({
  "& td": { border: 0, paddingLeft: 0 },
}))

const LessonsPage = () => {
  const { schedule } = useContext(DataContext)
  const { id: scheduleId } = schedule
  const { lessons, loading } = useFetchLessons({ scheduleId })

  const columns = [
    {
      id: "name",
      label: "Session Type",
      align: "left",
      minWidth: 200,
    },
    {
      id: "started_on",
      label: "Session Date",
      align: "right",
      minWidth: 150,
    },
  ]
  if (!scheduleId || loading) return <LoadingSpinner />

  return (
    <BRTThemeProvider>
      <div className="card session-information mb-4">
        <h6 className="font-weight-semibold mb-0 flex-grow-1"> Session history</h6>
        <div>
          {!lessons.length ? (
            <NoAssignmentSessions />
          ) : (
            <TableContainer sx={{ maxHeight: 515 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <StyledTableHeader>
                    {columns.map(column => (
                      <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                        {column.label}
                      </TableCell>
                    ))}
                  </StyledTableHeader>
                </TableHead>
                <TableBody>
                  {lessons.map(row => {
                    return (
                      <StyledTableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row.code}
                      >
                        {columns.map(column => {
                          const value = row[column.id]
                          return (
                            <TableCell key={column.id} align={column.align}>
                              {column.format && typeof value === "number" ? column.format(value) : value}
                            </TableCell>
                          )
                        })}
                      </StyledTableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </div>
      </div>
    </BRTThemeProvider>
  )
}

export default LessonsPage